var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M8.6 925.4c-.3-2.2-6.6-55.3 9.9-127.4 9.7-42.1 25.2-82.4 46.2-119.7 26.2-46.6 60.9-88.6 103.2-124.9 42.6-36.5 91-64.2 143.9-82.4 42.2-14.3 87.2-22.8 133.8-25 73.1-3.4 127.3 9.7 137.2 12.3 8.3 1.6 45.7 9.8 93.2 33.2 16.1 7.9 22.7 27.4 14.8 43.5-7.9 16.1-27.4 22.7-43.5 14.8-43.3-21.3-76.1-27.6-77.5-27.9-1.1-.2-2-.4-3.2-.7-.4-.1-50.9-13.8-120.3-10.2-91.2 4.7-170.6 35.6-236.1 91.7-65.6 56.2-108.6 126-127.9 207.3-14.4 61.5-9.3 107-9.2 107.5v-.1l-64.5 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M469.1 65.8c50.3 0 97.6 19.6 133.2 55.2 35.6 35.6 55.2 82.9 55.2 133.2s-19.6 97.6-55.2 133.2c-35.6 35.6-82.9 55.2-133.2 55.2-50.3 0-97.6-19.6-133.2-55.2s-55.2-82.9-55.2-133.2c0-50.3 19.6-97.6 55.2-133.2 35.6-35.6 82.9-55.2 133.2-55.2m0-65C329.2.8 215.7 114.2 215.7 254.2c0 139.9 113.4 253.4 253.4 253.4 139.9 0 253.4-113.4 253.4-253.4C722.5 114.3 609 .8 469.1.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222650",
    d: "M985.9 911.9H878.8l-169.4-.2H602c-17.9 0-32.5-14.6-32.5-32.5V709.5c0-17.9 14.6-32.5 32.5-32.5h106.9l169.5-.1h107.4c17.9 0 32.5 14.6 32.5 32.5v170.1c.1 17.9-14.4 32.4-32.4 32.4zm-351.4-65.2h74.9l169.4.2h74.6V741.8h-74.9l-169.6.2h-74.4v104.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCancelled);
export default ForwardRef;